import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { JPYs, secondsToHms } from '../common/Common';
import { useEffect, useState } from 'react';
import { WorkType, WorkTypeGroup } from '../common/enums';
import { BlankTypes } from '../common/Constant';

const IQ3KouteiBetsuKesanshiki_2jikakou = (props) => {
  const [isDantoriOpen, setIsDantoriOpen] = useState(true);
  const [isKakouOpen, setIsKakouOpen] = useState(true);
  const [openInputSubDetailKeys, setOpenInputSubDetailKeys] = useState(new Set());

  const [processInput, setProcessInput] = useState([]);

  // 重量
  const weight = Number(props?.data?.weight);
  // 面積
  const area = Number(props?.data?.totalSurfaceArea);

  // 数量
  const quantity = props?.estimateData?.estimateProducts?.quantity
    ? Number(props?.estimateData?.estimateProducts?.quantity)
    : 1;
  // 員数
  const partCnt = props?.data?.partCount ? Number(props?.data?.partCount) : 1;

  const getProductionQuantityCoeff = (deviceMst) => {
    let productionQuantityCoeff = 1;
    let quantity = Number(props?.estimateData?.estimateProducts?.quantity);
    let partCnt = Number(props?.data?.partCount); // 員数
    let manufacturingCnt = quantity * partCnt; // 製造数 * 員数
    // 生産個数係数
    let productionCoeffTh = deviceMst?.details?.productionQtyCoeffThMaster?.filter(
      (item) => (item.value == manufacturingCnt || item.value > manufacturingCnt) && !item.isOutOfRange
    );
    if (productionCoeffTh) {
      let productionCoeffThNo =
        productionCoeffTh?.length > 0
          ? productionCoeffTh[0]?.no
          : deviceMst?.details?.productionQtyCoeffThMaster?.[0]?.no;
      let productionCoeff =
        productionCoeffThNo == 0
          ? 0
          : deviceMst?.details?.productionQtyCoeffThItems?.filter(
              (item) => item.no == productionCoeffThNo && !item.isOutOfRange
            )[0]?.value;

      productionQuantityCoeff = productionCoeff ? productionCoeff : 1;
    }
    return productionQuantityCoeff;
  };

  const productionQuantityCoeff = getProductionQuantityCoeff(props?.deviceMst);

  useEffect(() => {
    let processInput = props?.data?.processInput?.filter((item) => item.processId == props?.processMst?.id)[0];
    if (processInput) {
      setProcessInput(processInput);
    }
  }, [props?.data]);

  const dantoriOpen = () => {
    if (isDantoriOpen) {
      setIsDantoriOpen(false);
    } else {
      setIsDantoriOpen(true);
    }
  };

  const kakouOpen = () => {
    if (isKakouOpen) {
      setIsKakouOpen(false);
    } else {
      setIsKakouOpen(true);
    }
  };

  const toggleInputSubDetail = (parentKey, index) => {
    const key = `${parentKey}-${index}`;
    setOpenInputSubDetailKeys((prevKeys) => {
      const newKeys = new Set(prevKeys);
      if (newKeys.has(key)) {
        newKeys.delete(key);
      } else {
        newKeys.add(key);
      }
      return newKeys;
    });
  };

  const calDandoriTime = (deviceMst, weight, area, weldTypeId) => {
    if (deviceMst == undefined || deviceMst?.length == 0) return 0;

    //　基本段取時間＊サイズ係数
    let deviceDandori = Object.entries(deviceMst?.details?.prepSecs)?.filter(
      ([key, data]) => parseInt(key) === weldTypeId
    )?.[0];
    let deviceDandoriTm = 0;
    deviceDandori?.map((item, index) => {
      if (index > 0) {
        deviceDandoriTm = item;
      }
    });

    // let dandoriTimeSec = deviceDandoriTm * partsCoeff;
    let dandoriTimeSec = deviceDandoriTm;
    dandoriTimeSec = dandoriTimeSec ? dandoriTimeSec : 0;
    //dandoriTimeSec = dandoriTimeSec * getSetupCoeff(deviceMst); // IQX_WEBEST-278 基本段取時間＊段取個数係数
    return dandoriTimeSec;
  };

  const calDandoriAmt = (dandoriTimeSec, newState) => {
    //段階時間
    let mSetTimeMin = dandoriTimeSec / 60;
    //装置の段階時間チャージ
    let mSetHRate = 0;

    let deviceCharges = Object.entries(deviceMst?.details?.charges)?.filter(
      ([key, data]) => parseInt(key) === newState?.processTypeId
    )?.[0];

    deviceCharges?.map((item, index) => {
      if (index > 0) {
        mSetHRate = item?.prep;
      }
    });

    //段階時間＊時間チャージ
    let dandoriAmt = (mSetTimeMin * mSetHRate) / 60.0;
    dandoriAmt = Number.isFinite(dandoriAmt) ? dandoriAmt : 0;
    return dandoriAmt;
  };

  const getSagyoTime = (deviceMst, sizeMm, typeId, groupTypeId, processMst) => {
    if (deviceMst == undefined || deviceMst?.length == 0) return 0;
    let thMaster = [];
    let workTime = 0;
    // IQX_WEBEST-295 詳細入力の値を見積計算で使用してほしい
    let parameters = props?.estimateData?.estimateProducts?.calcParameters?.parameters;
    //材質
    let materialTypeIq3Id = props?.data?.materialTypeIq3Id;
    //材質区分
    let materialTypeId = props?.parameters?.materialTypeIq3?.filter((item) => item.id == materialTypeIq3Id)?.[0]
      ?.materialTypeId;
    // 板厚
    let thickness = props?.parameters?.materialIq3?.filter((item) => item.id == props?.data?.thickness)?.[0]?.info
      ?.thick;

    if (groupTypeId === WorkTypeGroup.SmSecondaryWorkSize) {
      thMaster = deviceMst?.details?.sizeThMaster?.filter(
        (item) => (item.value == sizeMm || item.value > sizeMm) && !item.isOutOfRange
      )?.[0];

      let workTimeSizeThItems = Object.entries(deviceMst?.details?.workTimeSizeThItems)?.filter(
        ([key, data]) => parseInt(key) === typeId && !data.isOutOfRange
      )?.[0];

      workTimeSizeThItems?.map((item, index) => {
        if (index > 0) {
          // IQX_WEBEST-295 詳細入力の値を見積計算で使用してほしい
          let workTimeSizeThItem = item?.filter((item) => parseInt(item.no) == thMaster?.no && !item.isOutOfRange)?.[0];
          if (workTimeSizeThItem) {
            if (deviceMst?.details?.isUsedEasyWorkSpeed === undefined || deviceMst?.details?.isUsedEasyWorkSpeed) {
              workTime = workTimeSizeThItem?.value;
            } else {
              let sizeThicknessId = deviceMst?.details?.sizeThicknessThMaster?.filter(
                (item) => (item.value == thickness || item.value > thickness) && !item?.isOutOfRange
              )?.[0];
              let workTimeItem = workTimeSizeThItem?.workTimeThickThItems[materialTypeId]?.filter(
                (item) => item.no == sizeThicknessId?.no && !item?.isOutOfRange
              )?.[0];
              if (workTimeItem) {
                workTime = workTimeItem?.value;
              }
            }
          }
        }
      });
    } else {
      // IQX_WEBEST-432 成形型穴と多工程穴で分けて表を作って欲しい
      const secondaryDetails = props?.processMst?.details;
      if (secondaryDetails?.processDetailTypes?.length > 0) {
        let typeInfo = secondaryDetails?.processDetailTypes?.filter((i) => i.id === typeId && i.isUsed);
        if (typeInfo?.length > 0) {
          let typeNm = typeInfo[0]?.name;
          if (typeNm?.includes('成形型')) {
            thMaster = deviceMst?.details?.mmThMaster?.filter(
              (item) => (item.value == sizeMm || item.value > sizeMm) && !item.isOutOfRange
            )?.[0];

            let workTimeSizeHoleThItems = Object.entries(deviceMst?.details?.workTimeSizeHoleThItems)?.filter(
              ([key, data]) => parseInt(key) === typeId && !data.isOutOfRange
            )?.[0];

            workTimeSizeHoleThItems?.map((item, index) => {
              if (index > 0) {
                // IQX_WEBEST-295 詳細入力の値を見積計算で使用してほしい
                let workTimeSizeThItem = item?.filter(
                  (item) => parseInt(item.no) == thMaster?.no && !item.isOutOfRange
                )?.[0];
                if (workTimeSizeThItem) {
                  if (
                    deviceMst?.details?.isUsedEasyWorkSpeed === undefined ||
                    deviceMst?.details?.isUsedEasyWorkSpeed
                  ) {
                    workTime = workTimeSizeThItem?.value;
                  } else {
                    let sizeThicknessId = deviceMst?.details?.sizeThicknessThMaster?.filter(
                      (item) => (item.value == thickness || item.value > thickness) && !item?.isOutOfRange
                    )?.[0];
                    let workTimeItem = workTimeSizeThItem?.workTimeThickThItems[materialTypeId]?.filter(
                      (item) => item.no == sizeThicknessId?.no && !item?.isOutOfRange
                    )?.[0];
                    if (workTimeItem) {
                      workTime = workTimeItem?.value;
                    }
                  }
                }
              }
            });
          } else {
            thMaster = deviceMst?.details?.mmMultiProcHoleThMaster?.filter(
              (item) => (item.value == sizeMm || item.value > sizeMm) && !item.isOutOfRange
            )?.[0];

            let workTimeMmMultiProcHoleThItems = Object.entries(
              deviceMst?.details?.workTimeMmMultiProcHoleThItems
            )?.filter(([key, data]) => parseInt(key) === typeId && !data.isOutOfRange)?.[0];

            workTimeMmMultiProcHoleThItems?.map((item, index) => {
              if (index > 0) {
                // IQX_WEBEST-295 詳細入力の値を見積計算で使用してほしい
                let workTimeMmMultiProcHoleThItem = item?.filter(
                  (item) => parseInt(item.no) == thMaster?.no && !item.isOutOfRange
                )?.[0];
                if (workTimeMmMultiProcHoleThItem) {
                  if (
                    deviceMst?.details?.isUsedEasyWorkSpeed === undefined ||
                    deviceMst?.details?.isUsedEasyWorkSpeed
                  ) {
                    workTime = workTimeMmMultiProcHoleThItem?.value;
                  } else {
                    let sizeThicknessId = deviceMst?.details?.sizeThicknessThMaster?.filter(
                      (item) => (item.value == thickness || item.value > thickness) && !item?.isOutOfRange
                    )?.[0];
                    let workTimeItem = workTimeMmMultiProcHoleThItem?.workTimeThickThItems[materialTypeId]?.filter(
                      (item) => item.no == sizeThicknessId?.no && !item?.isOutOfRange
                    )?.[0];
                    if (workTimeItem) {
                      workTime = workTimeItem?.value;
                    }
                  }
                }
              }
            });
          }
        }
      }
    }
    workTime = workTime ? workTime : 0;
    return workTime;
  };

  const getHoseCoeff = (deviceMst, weight, area) => {
    if (deviceMst == undefined || deviceMst?.length == 0) return 0;
    // 段取時間設定

    // 重量
    let mtWeightThMaster = deviceMst?.details?.mtWeightThMaster?.filter(
      (item) => (item.value == weight || item.value > weight) && !item.isOutOfRange
    );
    // 面積
    let mtAreaThMaster = deviceMst?.details?.mtAreaThMaster?.filter(
      (item) => (item.value == area || item.value > area) && !item.isOutOfRange
    );
    let childPartsCoeffs =
      mtWeightThMaster?.length > 0 && mtAreaThMaster?.length > 0
        ? deviceMst?.details?.mtTimeCoeffItems?.filter((item) => item.weightId == mtWeightThMaster[0]?.no)
        : deviceMst?.details?.mtTimeCoeffItems[0];

    // 補正係数
    let partsCoeff =
      childPartsCoeffs?.length > 0
        ? childPartsCoeffs?.[0]?.areaCoeffList?.filter(
            (item) => item.no == mtAreaThMaster?.[0]?.no && !item.isOutOfRange
          )?.[0]?.value
        : childPartsCoeffs?.[0]?.areaCoeffList?.[0]?.value;
    partsCoeff = partsCoeff ? partsCoeff : 0;
    return partsCoeff;
  };

  return (
    <div className="kouteiCalculateDiv" id="kouteiCalculateDivID">
      <Row
        style={{ paddingLeft: 10, width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}
        onClick={() => dantoriOpen()}
      >
        <Col span={4} style={{ paddingLeft: 20 }}>
          {isDantoriOpen ? (
            <CaretUpOutlined style={{ fontSize: 18, marginTop: 5 }} />
          ) : (
            <CaretDownOutlined style={{ fontSize: 18, marginTop: 5 }} />
          )}
          <label style={{ marginLeft: 5 }}>{'段取金額/時間'}</label>
        </Col>
      </Row>
      <div style={{ display: isDantoriOpen ? 'block' : 'none', marginLeft: 10 }}>
        {processInput?.details?.length > 0 ? (
          processInput.details.map((detail, index) => {
            // 1. Data Prep
            const typeName =
              props?.processMst?.details?.processDetailTypes?.find((t) => t.id == detail.types)?.name || '不明';
            const detailKey = `dantori-detail-${index}`;
            const isOpen = openInputSubDetailKeys.has(detailKey);

            /** 段取金額/時間 */
            // 基本段取時間＊サイズ係数
            let dandoriTimeSec = calDandoriTime(props?.deviceMst, weight, area, detail?.types);

            // 段取金額設定
            //段階時間
            let mSetTimeMin = Number.isFinite(dandoriTimeSec / 60) ? dandoriTimeSec / 60 : 0;
            let deviceCharges = Object.entries(props?.deviceMst?.details?.charges)?.filter(
              ([key, data]) => parseInt(key) === detail?.types
            )?.[0];

            let mSetHRate = 0;
            deviceCharges?.map((item, index) => {
              if (index > 0) {
                mSetHRate = item?.prep;
              }
            });
            let dandoriAmt = (mSetTimeMin * mSetHRate) / 60.0; //段階時間＊時間チャージ =
            dandoriAmt = Number.isFinite(dandoriAmt) ? dandoriAmt : 0;

            return (
              <div key={`dantori-${index}`} style={{ width: '100%', borderBottom: '1px solid #ddd' }}>
                <Row
                  style={{ width: '100%', cursor: 'pointer', padding: '4px 0' }}
                  onClick={() => toggleInputSubDetail('dantori-detail', index)}
                >
                  <Col span={10} style={{ paddingLeft: 30 }}>
                    {isOpen ? (
                      <CaretUpOutlined style={{ fontSize: 18 }} />
                    ) : (
                      <CaretDownOutlined style={{ fontSize: 18 }} />
                    )}
                    <label style={{ marginLeft: 5 }}>{typeName}</label>
                  </Col>
                </Row>

                {isOpen && (
                  <div>
                    <div>
                      <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
                        <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'段取時間'}</label>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'段取金額'}</label>
                          </div>
                        </Col>
                        <Col span={12} style={{ paddingTop: 10 }}>
                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'基本段取時間'}</label>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'段取時間(秒) x 段取時間チャージ/3600(秒)'}</label>
                          </div>
                        </Col>
                        <Col span={8} style={{ paddingTop: 10 }}>
                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{`${dandoriTimeSec} (${secondsToHms(dandoriTimeSec)})`}</label>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{`${dandoriTimeSec} × ${mSetHRate} / 3600 = ${JPYs.format(
                              Math.round(dandoriAmt)
                            )}`}</label>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <div style={{ padding: '10px 40px', fontSize: 11, color: '#999' }}>詳細データはありません。</div>
        )}
      </div>

      {/* SECTION 2: 加工金額/時間 (Work) */}
      <Row
        style={{ paddingLeft: 10, width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer', marginTop: 2 }}
        onClick={() => kakouOpen()}
      >
        <Col span={4} style={{ paddingLeft: 20 }}>
          {isKakouOpen ? (
            <CaretUpOutlined style={{ fontSize: 18, marginTop: 5 }} />
          ) : (
            <CaretDownOutlined style={{ fontSize: 18, marginTop: 5 }} />
          )}
          <label style={{ marginLeft: 5 }}>{'加工金額/時間'}</label>
        </Col>
      </Row>

      <div style={{ display: isKakouOpen ? 'block' : 'none', marginLeft: 10 }}>
        {processInput?.details?.length > 0 ? (
          processInput.details.map((detail, index) => {
            const typeName =
              props?.processMst?.details?.processDetailTypes?.find((t) => t.id == detail.types)?.name || '不明';
            const detailKey = `kakou-detail-${index}`;
            const isOpen = openInputSubDetailKeys.has(detailKey);

            // 作業時間（{(1つ当たりの加工時間	+	(加工補正時間	*	加工補正係数)｝	*	サイズ係数）
            // 1つ当たりの加工時間
            let sagyoTimePerSec = getSagyoTime(
              props?.deviceMst,
              Number(detail?.diameter),
              detail?.types,
              detail?.workTypeGroup,
              props?.processMst
            );
            sagyoTimePerSec = sagyoTimePerSec ? sagyoTimePerSec : 0;

            let sagyoTimeSec = 0;
            let sagyoTimePerCount = 0;
            let sameTypeIndex = 0;
            let sameTypeCnt = 1;
            let manufacturingCnt = quantity * partCnt;

            //装置の作業時間チャージ
            let mSagyoHRate = 0;
            let sagyoAmt = 0;

            let hoseCoeff = 0;
            let hoseTime = 0;

            let mSagyoTimeMin = 0;

            for (let m = 0; m < manufacturingCnt; m++) {
              hoseTime = 0;
              let curTypeCount = Number(detail?.count);

              let mainSecondaryWorkProcessInput = processInput?.details?.filter(
                (item) => item.workTypeGroup == WorkTypeGroup.SmSecondaryWorkSize
              );

              let sameTypeCntByCurType = mainSecondaryWorkProcessInput?.filter((item) => item.types === detail?.types);
              for (let s = 0; s < sameTypeCntByCurType?.length; s++) {
                if (m > 0 || sameTypeCntByCurType[s]?.id !== detail?.id) {
                  sameTypeCnt += Number(sameTypeCntByCurType[s]?.count) + m;
                } else {
                  break;
                }
              }
              sameTypeIndex = sameTypeCnt;
              for (let i = 0; i < curTypeCount; i++) {
                let hoseCount = sameTypeIndex + i;
                // 加工補正時間
                let modifyTimeQtyThMaster = props?.deviceMst?.details?.modifyTimeQtyThMaster?.filter(
                  (item) => (item.value == hoseCount || item.value > hoseCount) && !item.isOutOfRange
                )?.[0];
                hoseTime = props?.deviceMst?.details?.modifyTimeItems?.filter(
                  (item) => item.no == modifyTimeQtyThMaster?.no && !item.isOutOfRange
                )?.[0]?.value;

                // 加工補正係数
                hoseCoeff = getHoseCoeff(props?.deviceMst, weight, area);

                // 補正時間（補正時間×補正係数×生産個数係数）
                let hoseMultiply = hoseCoeff * hoseTime * productionQuantityCoeff;
                sagyoTimePerCount += sagyoTimePerSec + hoseMultiply;
              }

              // 加工時間　÷　製造数
              sagyoTimePerCount = Number.isFinite(sagyoTimePerCount / manufacturingCnt)
                ? sagyoTimePerCount / manufacturingCnt
                : 0;
              sagyoTimeSec = sagyoTimePerCount ? sagyoTimePerCount : 0;

              // 作業金額
              mSagyoTimeMin = Number.isFinite(sagyoTimeSec / 60) ? sagyoTimeSec / 60 : 0;

              let deviceCharges = Object.entries(props?.deviceMst?.details?.charges)?.filter(
                ([key, data]) => parseInt(key) === detail?.types
              )?.[0];
              deviceCharges?.map((item, index) => {
                if (index > 0) {
                  mSagyoHRate = item?.work;
                }
              });
              sagyoAmt = (mSagyoTimeMin * mSagyoHRate) / 60.0; //作業時間＊時間チャージ
              sagyoAmt = Number.isFinite(sagyoAmt) ? sagyoAmt : 0;
            }

            return (
              <div key={`kakou-${index}`} style={{ width: '100%', borderBottom: '1px solid #ddd' }}>
                <Row
                  style={{ width: '100%', cursor: 'pointer', padding: '4px 0' }}
                  onClick={() => toggleInputSubDetail('kakou-detail', index)}
                >
                  <Col span={10} style={{ paddingLeft: 30 }}>
                    {isOpen ? (
                      <CaretUpOutlined style={{ fontSize: 18 }} />
                    ) : (
                      <CaretDownOutlined style={{ fontSize: 18 }} />
                    )}
                    <label style={{ marginLeft: 5 }}>{typeName}</label>
                  </Col>
                </Row>

                {isOpen && (
                  <div>
                    <div>
                      <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
                        <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'加工時間'}</label>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'加工金額'}</label>
                          </div>
                        </Col>
                        <Col span={12} style={{ paddingTop: 10 }}>
                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'1つ当たりの加工時間 + (補正時間 x 補正係数 x 生産個数係数) / 数量'}</label>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'加工時間(秒) x 加工時間チャージ/3600(秒)'}</label>
                          </div>
                        </Col>
                        <Col span={8} style={{ paddingTop: 10 }}>
                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{`(${sagyoTimePerSec} + (${hoseCoeff} x ${hoseTime} x ${productionQuantityCoeff})) / ${manufacturingCnt} = ${sagyoTimeSec} (${secondsToHms(
                              sagyoTimeSec
                            )})`}</label>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{`(${Math.round(mSagyoTimeMin)} × ${mSagyoHRate}) / 60 = ${JPYs.format(
                              Math.round(sagyoAmt)
                            )}`}</label>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <div style={{ padding: '10px 40px', fontSize: 11, color: '#999' }}>詳細データはありません。</div>
        )}
      </div>
    </div>
  );
};

export default IQ3KouteiBetsuKesanshiki_2jikakou;
